import { render, staticRenderFns } from "./CPVCheckList.vue?vue&type=template&id=b201ec3c&scoped=true&"
import script from "./CPVCheckList.vue?vue&type=script&lang=js&"
export * from "./CPVCheckList.vue?vue&type=script&lang=js&"
import style0 from "./CPVCheckList.vue?vue&type=style&index=0&id=b201ec3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b201ec3c",
  null
  
)

export default component.exports